<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii">THE AIR WAR</a></h1><a id="page_iii">
<h1 class="title1">AT SEA IN THE</h1>
<h1 class="title2">SECOND WORLD WAR</h1>
<div class="image_container">
<img alt="images" src="images/line.jpg"/>
</div>
<p class="author">MARTIN W. BOWMAN</p>
<div class="image_container">
<img alt="images" src="images/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?bfb68986